import { MapComponent } from './../map.component';
import { count } from 'rxjs/operator/count';
import { LocalStorage } from './../../shared/localstorage.service';
import { MapService } from './../../shared/map.service';
import { CountyPlaceExtension, CountyPlaceFeature } from './../../shared/searchcountyplace.model';
import { Component, OnInit, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: "app-searchMap",
  templateUrl: "./searchMap.component.html",
  styleUrls: ["./searchMap.component.scss"]
})

export class SearchMapComponent implements OnInit {

  token: string;
  county: string = '';
  place: string = '';
  streetAddress: string = '';
  streetPrefix: string = '';
  streetName: string = '';
  streetType: string = '';
  streetSuffix: string = '';
  intersection: string = '';
  full: string = '';
  submitted = false;
  selectedFormat: string;
  gpsformats: string[] = ['Coordinated (Format: Lat, Long)', 'Degrees (Format: D.D)', 'Degrees Minutes Seconds (Format: D M S)', 'Degrees Minutes (Format: D M.M)'];

  countyListExtension: CountyPlaceExtension;
  placeListExtension: CountyPlaceExtension;
  countyList: CountyPlaceFeature[] = [];

  placeList: CountyPlaceFeature[] = [];

  constructor(public dialogRef: MatDialogRef<SearchMapComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    public service: MapService,
    public localstorage: LocalStorage) { }

  ngOnInit() {
    this.token = this.localstorage.getItem('token');
    this.service.getCounty(this.token, this.localstorage.getItem('currentState')).subscribe(res => {
      this.countyListExtension = res['extension'];
      this.countyListExtension.feature.forEach(element =>
        this.countyList.push(element));
    });
    this.county = this.data.county;
    this.onCountySelect();
    this.place = this.data.place;
  }

  OnCloseConfirm() {
    this.full = this.county + "," + this.place + "," + this.streetAddress + "," + this.streetPrefix + "," + this.streetName + "," + this.streetType + "," + this.streetSuffix + "," + this.intersection;
    this.dialogRef.close(this.full);
  }

  OnCloseCancel() {
    this.dialogRef.close('Cancel');
  }

  onCountySelect() {
    this.placeList = [];
    if (this.county !== null || this.county !== '') {
      this.token = this.localstorage.getItem('token');
      this.service.getPlace(this.token, this.county, this.localstorage.getItem('currentState')).subscribe(res => {
        this.placeListExtension = res['extension'];
        this.placeListExtension.feature.forEach(element =>
          this.placeList.push(element));
      });
    }
  }

  showErrors(form) {
    this.submitted = true;
    form.form.controls.county.touched = true;
    form.form.controls.place.touched = true;
    form.form.controls.streetName.touched = true;
  }
}
